export default __webpack_public_path__ + "static/media/thumb_2_kwho.acf10c08.png";